 
import React, { Fragment, ReactElement } from 'react';

import {
  Button,
  ButtonPattern,
  Container,
  Grid,
  GridItem,
  Link,
  Notification,
  Paragraph,
  Text,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import PageHeading from 'components/pageHeading/PageHeading';
import StyledBox from 'components/style/styledBox/StyledBox';

import { TechnicalErrorPageContent } from './TechnicalErrorPageContent';

function TechnicalErrorPage(): ReactElement {
  const { technicalErrorPageContent } = useContent<TechnicalErrorPageContent>();

  return (
    <Container padding="none">
      {technicalErrorPageContent &&
        technicalErrorPageContent.map(
          ({
            serviceName,
            header,
            errorNotificationHeading,
            errorNotificationInfo,
            technicalErrorPageContents,
            backToWebsiteButton,
            backToWebsiteLink,
          }) => (
            <Fragment key="call-us-content">
              <PageHeading serviceName={serviceName} header={header} />
              <Grid alignX="left" alignY="top">
                <GridItem lg={8}>
                  <StyledBox>
                    <Notification
                      sentiment="critical"
                      heading={errorNotificationHeading}
                    >
                      <Text size="s2">{errorNotificationInfo}</Text>
                    </Notification>
                    <Paragraph size="s2" marginBottom="03">
                      <Text weight="bold">
                        {technicalErrorPageContents.content1}
                      </Text>{' '}
                      <Link
                        href={`tel:${technicalErrorPageContents.contactNo}`}
                        weight="bold"
                      >
                        <Text weight="bold" color="brand">
                          {technicalErrorPageContents.contactNo}
                        </Text>
                      </Link>
                      {technicalErrorPageContents.dot}{' '}
                      <Text>{technicalErrorPageContents.content2}</Text>
                    </Paragraph>
                    <Paragraph>
                      <Text>{technicalErrorPageContents.content3}</Text>{' '}
                      <Link
                        href={technicalErrorPageContents.callUsHelpLink}
                        weight="bold"
                        external
                      >
                        <Text color="brand">
                          {technicalErrorPageContents.callUsLabel}
                        </Text>
                      </Link>
                    </Paragraph>
                    <Paragraph>
                      <Link
                        href={technicalErrorPageContents.signVideoLink}
                        external
                      >
                        {technicalErrorPageContents.signVideoLabel}
                      </Link>{' '}
                      {technicalErrorPageContents.content4}
                    </Paragraph>
                    <ButtonPattern marginBottom="none">
                      <Button href={backToWebsiteLink}>
                        {backToWebsiteButton}
                      </Button>
                    </ButtonPattern>
                  </StyledBox>
                </GridItem>
              </Grid>
            </Fragment>
          ),
        )}
    </Container>
  );
}

export default TechnicalErrorPage;
